import api from './api-caller';
const baseEndpoint = '/certificates'

export default {
  getCertificate: (id) => {
    const endpoint = `${baseEndpoint}/${id}`
    return api(endpoint, 'GET')
  }
}
